module.exports = "<p class=\"o-tag\" :style=\"{backgroundColor: color}\">\n\t<slot></slot>\n</p>"